import { Asset } from 'src/app/data/schema/asset';
import { Utilities } from 'src/app/shared/helpers/util';

export class Sponsor {
    auctionId: number;
    name: string;
    sponsorId: number;
    newBanner: string;
    url: string;
    sortOrder: number;
    tier: string;
    description = '';
    logoPath: string;
    bannerPath: string;
    body: string;
    deleted: boolean;
    banner: Asset;
    title: string;

    // not tracked, but used for display
    displayUrl: string;

    constructor(sponsor?: Partial<Sponsor>) {
        Object.assign(this, sponsor);

        if (this.banner?.path) {
            this.logoPath = this.banner.path;
            this.bannerPath = this.banner.path;
        } 

        // if we have a url, then remove the https:// and www. from the url
        if (this.url) {
            this.displayUrl = Utilities.cleanUrl(this.url);
        }
    }
}
